import { useQuery } from '@tanstack/react-query'
import { fetchAnalyticsDashboard } from '../api/analyticsDashboardClient'

export function useAnalyticsDashboard() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['analytics-dashboard'],
    queryFn: ({ signal }) => fetchAnalyticsDashboard(signal),
    staleTime: 60_000,
    refetchInterval: 60_000,
  })

  return { data, isLoading, error }
}
